/* eslint-disable max-len */
import React, { useEffect } from 'react';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

export default function Tracking({ details, checkout }) {
  const onFacebookAccept = () => {
    if (!details?.event?.frontendSettings?.facebookPixelId) return;
    /* eslint-disable */
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', '1309054963686816');
    window.fbq('track', 'PageView');
    if (checkout) {
      window.fbq(
        'track',
        'Purchase',
        // begin parameter object data
        {
          value: checkout.total,
          currency: 'EUR',
          contents: checkout.lineItems
            .map((li) => ({
              id: li.product.code,
              quantity: li.quantity,
            })),
          content_type: 'product',
        },
        // end parameter object data
      );
    }
  };

  useEffect(() => {
    if (!details?.event) return;
    const config = {
      categories: {
        necessary: {
          enabled: true,
          readOnly: true,
        },
      },
      language: {
        default: 'de',
        translations: {
          de: {
            consentModal: {
              title: 'Cookie-Einstellungen',
              // eslint-disable-next-line max-len
              description: 'Wir verwenden Cookies, um die grundlegenden Funktionen der Website zu gewährleisten und Ihr Online-Erlebnis zu verbessern. Sie können Ihre Einstellungen verwalten oder alle Cookies akzeptieren.',
              acceptAllBtn: 'Alle akzeptieren',
              acceptNecessaryBtn: 'Nur notwendige akzeptieren',
              showPreferencesBtn: 'Einstellungen verwalten',
            },
            preferencesModal: {
              title: 'Cookie-Präferenzen',
              acceptAllBtn: 'Alle akzeptieren',
              acceptNecessaryBtn: 'Nur notwendige akzeptieren',
              savePreferencesBtn: 'Einstellungen speichern',
              closeIconLabel: 'Schließen',
              sections: [
                {
                  title: 'Verwendung von Cookies',
                  // eslint-disable-next-line max-len
                  description: 'Wir verwenden Cookies, um die grundlegenden Funktionen der Website zu gewährleisten und Ihr Online-Erlebnis zu verbessern. Sie können wählen, welche Cookies Sie zulassen möchten.',
                },
                {
                  title: 'Unbedingt erforderliche Cookies',
                  description: 'Diese Cookies sind für den Betrieb der Website notwendig und können nicht deaktiviert werden.',
                  linkedCategory: 'necessary',
                  cookieTable: {
                    headers: {
                      name: 'Name',
                      domain: 'Dienst',
                      description: 'Beschreibung',
                      expiration: 'Ablauf',
                    },
                    body: [
                      {
                        name: 'cf_clearance',
                        domain: 'Cloudflare',
                        description: 'Speichert, dass der Nutzer eine Sicherheitsprüfung (z. B. CAPTCHA) bestanden hat.',
                        expiration: 'Läuft nach 30 Minuten bis mehreren Stunden ab.',
                      },
                      {
                        name: 'connect.sid',
                        domain: 'Plattform-Session',
                        description: 'Speichert die Sitzung des Nutzers, damit die ausgewählten Information gespeichert bleiben.',
                        expiration: 'Läuft nach 5 Tagen ab.',
                      },
                      {
                        name: '__stripe_mid',
                        domain: 'Stripe',
                        description: 'Sitzungserkennung für die Zahlungsabwicklung.',
                        expiration: '1 Jahr',
                      },
                      {
                        name: '__stripe_sid',
                        domain: 'Stripe',
                        description: 'Kurzfristige Sitzungs-ID für Betrugsprävention.',
                        expiration: '30 Minuten',
                      },
                      {
                        name: 'm',
                        domain: 'Stripe',
                        description: 'Betrugserkennung und Sicherheitsmaßnahmen.',
                        expiration: '2 Jahre',
                      },
                    ],
                  },
                },
                {
                  title: 'Marketing- und Tracking-Cookies',
                  description: 'Diese Cookies werden verwendet, um das Nutzerverhalten zu analysieren und gezielte Werbung bereitzustellen.',
                  linkedCategory: 'marketing',
                  cookieTable: {
                    headers: {
                      name: 'Name',
                      domain: 'Dienst',
                      description: 'Beschreibung',
                      expiration: 'Ablauf',
                    },
                    body: [
                      {
                        name: '_fbp',
                        domain: 'Meta Conversion Pixel',
                        description: 'Cookie für Meta Conversion Pixel, um das Nutzerverhalten zu verfolgen.',
                        expiration: 'Läuft nach 90 Tagen ab',
                      },
                    ],
                  },
                },
                {
                  title: 'Weitere Informationen',
                  // eslint-disable-next-line max-len
                  description: 'Für Fragen zu unserer Cookie-Richtlinie und Ihren Auswahlmöglichkeiten <a class="cc-link" href="#yourdomain.com">kontaktieren Sie uns</a>.',
                },
              ],
            },
          },
        },
      },
    };
    if (details?.event?.frontendSettings?.facebookPixelId) {
      config.categories.marketing = {
        autoClear: {
          cookies: [
            { name: /^_fbp/ },
            { name: '_fbp' },
          ],
        },
        services: {
          ga: {
            label: 'Meta Conversion Pixel',
            onAccept: () => { onFacebookAccept(); },
          },
        },
      };
    }
    CookieConsent.run(config);
  }, [CookieConsent, details?.event?.frontendSettings?.facebookPixelId]);
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <></>
  );
}
